export const CONTROLLERS_FETCH_INIT = 'CONTROLLERS_FETCH_INIT';
export const CONTROLLERS_FETCH_SUCCESS = 'CONTROLLERS_FETCH_SUCCESS';
export const CONTROLLERS_FETCH_ERROR = 'CONTROLLERS_FETCH_ERROR';

export const CONTROLLERS_POST_INIT = 'CONTROLLERS_POST_INIT';
export const CONTROLLERS_POST_SUCCESS = 'CONTROLLERS_POST_SUCCESS';
export const CONTROLLERS_POST_ERROR = 'CONTROLLERS_POST_ERROR';

export const CONTROLLERS_RESET = 'CONTROLLERS_RESET';
